import './grid.css'
import './web_component'
import React from 'react'
import { GridLayoutProps } from './types'

export const Grid: React.FC<GridLayoutProps> = ({ children, ...props }) => <grid-l {...props}>{children}</grid-l>
